export function formatDateTimeFr(isoString: string): string {
  const date = new Date(isoString);

  const day = String(date.getDate()).padStart(2, '0');       // dd
  const month = String(date.getMonth() + 1).padStart(2, '0'); // mm
  const year = date.getFullYear();                           // aaaa

  const hours = String(date.getHours()).padStart(2, '0');    // hh
  const minutes = String(date.getMinutes()).padStart(2, '0'); // mm

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
